import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { LogComment, StepInstance } from '../../../models/projects/operation.models';
import { OperationService } from '../../../services/operations/operation/operation.service';
import { cloneDeep } from 'lodash';
import { NavHelperService } from '../../../services/nav/nav-helper.service';
import { LockedDayPermissions } from '../../../models/permissions/permission.models';
import { AppConfig } from '../../../app/app.config';
import { DailyLogModalPage } from '../../daily-log/daily-log-modal/daily-log-modal';
import { SupportContextKey } from '../../../models/support/support.models';
import { SupportContextService } from '../../../services/support/support-context.service';

@IonicPage()
@Component({
  selector: 'page-step-comments',
  templateUrl: 'step-comments.html',
})

export class StepCommentsPage {
  config = AppConfig.settings;
  tempComment: LogComment;
  originalComment: LogComment;
  stepInstance: StepInstance = new StepInstance();
  loading: boolean = true;
  lockedDayPermissions: LockedDayPermissions;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public operationService: OperationService,
              public navHelperService: NavHelperService,
              private toastCtrl: ToastController,
              private modalController: ModalController,
              private supportContextService: SupportContextService
  ) {
    this.stepInstance = navParams.get('stepInstance');
    this.lockedDayPermissions = navParams.get('lockedDayPermissions');
    this.tempComment = cloneDeep(this.stepInstance.comment);
    this.originalComment = this.tempComment ? cloneDeep(this.tempComment) : {data: undefined, appear: undefined, milestone: false};
  }

  ionViewDidEnter() {
    this.supportContextService.setComponentContext(SupportContextKey.EditOperation, 'Step Comments', 'StepCommentsPage');

    this.navHelperService.commentWarned = false;
    this.navHelperService.showCommentWarning = false;
    this.loading = false;
  }

  ionViewCanLeave(): boolean {
    if (this.navHelperService.unsavedComment && !this.navHelperService.commentWarned) {
      this.navHelperService.commentWarned = true;
      this.navHelperService.showCommentWarning = true;
      this.navHelperService.unsavedComment = false;
      return false;
    }
    return true;
  }

  commentChanged(comment: LogComment) {
    this.tempComment = comment;

    if (this.originalComment.data !== this.tempComment.data
      || this.originalComment.appear !== this.tempComment.appear
      || this.originalComment.milestone !== this.tempComment.milestone) {
      this.navHelperService.unsavedComment = true;
    } else {
      this.navHelperService.unsavedComment = false;
    }
  }

  save() {
    this.stepInstance.comment = this.tempComment;

    this.navHelperService.unsavedComment = false;

    this.navHelperService.unsavedChanges = true;

    this.presentSaveToast().then(() => {
      this.navCtrl.pop();
    });
  }

  presentSaveToast(): Promise<any> {
    const toast = this.toastCtrl.create({
      message: 'Comment Saved',
      duration: 3000,
      position: 'bottom'
    });

    return toast.present();
  }

  openDailyLogModal() {
    const dailyLogModal = this.modalController.create(DailyLogModalPage);
    dailyLogModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/operations/step-comments/step-comments.ts